import React, { useState, useEffect } from "react";
import { Box, Grid, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import SubHeader from "../../../common/SubHeader";
import Notification from "../../../ui/Notification";
import RenderStatus from "../../../ui/RenderStatus";
import CustomToolbar from "../../../ui/CustomToolBar";
import Route from "../../../routes/Route";
import TakeTest from "./TakeTest";
import { useCommon } from "../../../contexts/CommonContext";
import { shuffleArray } from "../../../util/CommonUtil";

const Test = () => {
  const { isMdUp } = useCommon();
  const [tests, setTests] = useState([]);
  const [id, setId] = useState(null);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [takeTest, setTakeTest] = useState(false);
  const [details, setDetails] = useState({});
  const [questions, setQuestions] = useState([]);
  const token = localStorage.getItem("token");
  const fetchTests = async () => {
    const res = await Route("GET", "/tests", token, null, null);
    if (res?.status === 200) {
      setTests(res?.data?.tests);
    }
  };
  useEffect(() => {
    fetchTests();
  }, []);
  const fetchQuestions = async (id, row) => {
    const res = await Route("GET", "/tests", token, null, id);
    if (res?.status === 200) {
      if (res?.data?.message == "You have Already Appeared for Test") {
        setMessage(res?.data?.message);
        setShowNotification(true);
      } else {
        setQuestions(shuffleArray(res?.data?.questions));
        setDetails(row);
        setTakeTest(true);
      }
    } else {
      setMessage(res?.data?.message);
      setShowNotification(true);
    }
  };
  const testHandle = (param) => {
    const now = new Date();
    const startDateStr = param?.row?.start_date?.split("T")[0];
    const endDateStr = param?.row?.end_date?.split("T")[0];
    const startTimeStr = param?.row?.start_time?.trim();
    const endTimeStr = param?.row?.end_time?.trim();

    if (!startDateStr || !startTimeStr || !endDateStr || !endTimeStr) {
      setMessage("Missing or invalid test date/time information.");
      setShowNotification(true);
      return;
    }
    // Combine into ISO strings
    const startDateTime = new Date(`${startDateStr}T${startTimeStr}`);
    const endDateTime = new Date(`${endDateStr}T${endTimeStr}`);
    // Confirm parsing worked
    if (isNaN(startDateTime.getTime()) || isNaN(endDateTime.getTime())) {
      setMessage("Invalid test schedule (date/time parsing failed).");
      setShowNotification(true);
      return;
    }
    // Validate against current time
    if (now < startDateTime) {
      setMessage("You can't take the test yet. It hasn't started.");
      setShowNotification(true);
    } else if (now > endDateTime) {
      setMessage("You can't take the test anymore. It is already closed.");
      setShowNotification(true);
    } else {
      fetchQuestions(param?.row?.id, param?.row);
    }
  };

  const userColumns = [
    {
      field: "sl",
      headerName: "Sl. No",
      flex: isMdUp ? 40 : undefined,
      width: isMdUp ? undefined : 40,
    },
    {
      field: "name",
      headerName: "Test Name",
      flex: isMdUp ? 200 : undefined,
      width: isMdUp ? undefined : 200,
    },
    {
      field: "start_date",
      headerName: "Start Date",
      flex: isMdUp ? 100 : undefined,
      width: isMdUp ? undefined : 140,
      valueGetter: (params) => params.row.start_date.split("T")[0],
    },
    {
      field: "start_time",
      headerName: "Start Time",
      flex: isMdUp ? 100 : undefined,
      width: isMdUp ? undefined : 140,
    },
    {
      field: "end_date",
      headerName: "End Date",
      flex: isMdUp ? 100 : undefined,
      width: isMdUp ? undefined : 140,
      valueGetter: (params) => params.row.end_date.split("T")[0],
    },
    {
      field: "end_time",
      headerName: "End Time",
      flex: isMdUp ? 100 : undefined,
      width: isMdUp ? undefined : 140,
    },
    {
      field: "duration",
      headerName: "Duration",
      flex: isMdUp ? 100 : undefined,
      width: isMdUp ? undefined : 140,
    },
    {
      field: "status",
      headerName: "Status",
      flex: isMdUp ? 100 : undefined,
      width: isMdUp ? undefined : 140,
      renderCell: (params) => (
        <RenderStatus
          status={params.row.status === true ? "Active" : "Inactive"}
        />
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: isMdUp ? 100 : undefined,
      width: isMdUp ? undefined : 140,
      renderCell: (params) => (
        <div>
          <IconButton
            aria-label="edit"
            size="small"
            onClick={() => testHandle(params)}
            color="primary"
          >
            <EditIcon />
          </IconButton>
        </div>
      ),
    },
  ];
  return (
    <>
      {takeTest ? (
        <TakeTest
          details={details}
          setTakeTest={setTakeTest}
          questions={questions}
        />
      ) : (
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={4} alignItems="center" sx={{ px: 2 }}>
            <SubHeader text="Test" />
            <Grid item container alignItems="center" xs={12}>
              <div style={{ height: "auto", width: "100%" }}>
                <DataGrid
                  rows={tests
                    ?.sort((a, b) => b.id - a.id)
                    ?.map((row, index) => ({
                      ...row,
                      sl: index + 1,
                    }))}
                  columns={userColumns}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 10 },
                    },
                  }}
                  pageSizeOptions={[10, 20]}
                  slots={{ toolbar: CustomToolbar }}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      )}

      {showNotification ? (
        <Notification
          open={showNotification}
          setOpen={setShowNotification}
          message={message}
        />
      ) : null}
    </>
  );
};

export default Test;
